import React, { useEffect, useState } from 'react';
import { getdatanoauth, WAITINGGIF, sendwhatsappmessageapi } from '../../util/global';
import TableExpense from './TableExpense';
import KitLoader from '../../components/kitsters/KitLoader';

const ExpenseAttachmentCheck = () => {
  const [expensedata, setexpensedata] = useState([]);
  const [loading, setLoading] = useState(true);
  const params = new URLSearchParams(window.location.search);


  useEffect(() => {
    const start = Date.now();
    const adminuserid = window.APPUSER?.user?.token ? window.APPSETTING.adminuserid : params.get('adminuserid');
    getdatanoauth({ zohodatatype: 'expenses', _adminuserid: adminuserid }, '/zohodatanoauth')
      .then(res => setexpensedata(res.data))
      .catch(err => console.error(err))
      .finally(() => {
        const elapsed = Date.now() - start;
        const remaining = Math.max(0, 700 - elapsed);
        setTimeout(() => setLoading(false), remaining);
      });
  }, []);

  return (
    <div className="content-area" style={{ position: 'relative', minHeight: 'calc(100vh - 140px)' }}>
      {loading && <KitLoader />}
      <h3 style={{ marginBottom: '16px' }}>Expenses without attachment | Problem Count: {expensedata.length}</h3>
      <TableExpense expensedata={expensedata} />
    </div>
  );
};

export default ExpenseAttachmentCheck;
